import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_bar = _resolveComponent("q-bar")!

  return (_openBlock(), _createBlock(_component_q_bar, {
    class: "col justify-center text-center bg-brand-warning q-py-xs text-white font-caption-mini",
    style: _normalizeStyle(`height: ${_ctx.TEST_MODE_BANNER_HEIGHT};`)
  }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("b", null, "Внимание!", -1),
      _createTextVNode("   Вы находитесь на тестовой версии платформы ")
    ])),
    _: 1
  }, 8, ["style"]))
}